{
  "sidebar": {
    "title": "Sidebar",
    "mobileDescription": "Displays the mobile sidebar.",
    "toggle": "Toggle Sidebar"
  },
  "nav": {
    "dashboard": "Dashboard",
    "counters": "Counters",
    "users": "Users",
    "activityHistory": "Activity",
    "profile": "Profile",
    "settings": "Settings",
    "collapse": "Collapse",
    "logout": "Logout"
  },
  "theme": {
    "light": "Light",
    "dark": "Dark",
    "system": "System"
  },
  "language": {
    "en": "English",
    "es": "Español",
    "sr": "Српски"
  },
  "common": {
    "user": "User",
    "cancel": "Cancel",
    "save": "Save",
    "dismiss": "Dismiss"
  },
  "login": {
    "title": "Welcome back",
    "description": "Enter your credentials to sign in to your account",
    "identifier": {
      "username": "Username",
      "email": "Email",
      "both": "Username or email",
      "placeholder": "Enter your {{field}}"
    },
    "password": {
      "label": "Password",
      "placeholder": "Enter your password"
    },
    "button": "Sign in",
    "button.loading": "Signing in...",
    "error": {
      "identifierRequired": "{{field}} is required",
      "passwordLength": "Password must be at least 6 characters",
      "failed": "Login failed",
      "unknown": "An unexpected error occurred"
    },
    "forgotPassword": "Forgot password?",
    "noAccount": "Don't have an account?",
    "signUp": "Sign up"
  },
  "invitation": {
    "title": "Complete Your Registration",
    "description": "Set your password to activate your account",
    "username": "Username",
    "password": "Password",
    "passwordPlaceholder": "Enter your password",
    "confirmPassword": "Confirm Password",
    "confirmPasswordPlaceholder": "Confirm your password",
    "button": "Set Password & Activate",
    "button.loading": "Setting up...",
    "invalidTitle": "Invalid Invitation",
    "goToLogin": "Go to Login",
    "resetPassword": {
      "title": "Reset Your Password",
      "description": "Enter a new password for your account",
      "button": "Reset Password",
      "button.loading": "Resetting..."
    },
    "error": {
      "noToken": "No invitation token provided",
      "invalidToken": "Invalid or expired invitation token",
      "passwordLength": "Password must be at least 8 characters",
      "passwordMismatch": "Passwords do not match",
      "failed": "Failed to set password. Please try again."
    }
  },
  "profile": {
    "title": "My Account",
    "subtitle": "Manage your profile and security settings",
    "edit": "Edit",
    "verified": "Verified",
    "updateSuccess": "Profile updated successfully",
    "updateError": "Failed to update profile",
    "info": {
      "title": "Profile Information",
      "description": "Your account details"
    },
    "field": {
      "name": "Full Name",
      "username": "Username",
      "email": "Email",
      "memberSince": "Member Since"
    },
    "editModal": {
      "title": "Edit Profile",
      "description": "Update your profile information"
    },
    "security": {
      "title": "Change Password",
      "description": "Update your password to keep your account secure",
      "currentPassword": "Current Password",
      "newPassword": "New Password",
      "confirmPassword": "Confirm New Password",
      "passwordMismatch": "Passwords do not match",
      "passwordInvalid": "Password does not meet requirements",
      "changeSuccess": "Password changed successfully. Other sessions have been logged out.",
      "changeError": "Failed to change password",
      "changeButton": "Change Password"
    },
    "sessions": {
      "currentSession": "Current Session",
      "current": "Current",
      "device": "Device",
      "ip": "IP Address",
      "lastActive": "Last Active",
      "now": "Now",
      "unknown": "Unknown",
      "otherSessions": "Other Sessions",
      "otherDescription": "Sessions active on other devices",
      "revokeAll": "Revoke All",
      "revoke": "Revoke",
      "revokeSuccess": "Session revoked successfully",
      "revokeError": "Failed to revoke session",
      "revokeAllSuccess": "All other sessions have been logged out",
      "revokeAllError": "Failed to revoke sessions",
      "noOtherSessions": "No other active sessions",
      "lastActiveAt": "Last active {{time}}",
      "neverActive": "Never active",
      "confirmRevokeAll": {
        "title": "Revoke All Sessions",
        "description": "This will log out all other devices. You will remain logged in on this device."
      },
      "time": {
        "daysAgo": "{{count}}d ago",
        "hoursAgo": "{{count}}h ago",
        "justNow": "just now",
        "minutesAgo": "{{count}}m ago"
      },
      "unknownBrowser": "Unknown browser",
      "unknownDevice": "Unknown device"
    }
  },
  "settings": {
    "title": "Settings",
    "subtitle": "Manage your application preferences",
    "theme": "Theme",
    "themeDescription": "Select your preferred theme",
    "language": "Language",
    "languageDescription": "Select your preferred language"
  },
  "users": {
    "title": "Users",
    "button": {
      "add": "Add User",
      "resetPassword": "Reset Password",
      "resendInvitation": "Resend Invitation",
      "deactivate": "Deactivate",
      "activate": "Activate",
      "demoteFromAdmin": "Demote from Admin",
      "promoteToAdmin": "Promote to Admin"
    },
    "table": {
      "username": "Username",
      "email": "Email",
      "name": "Name",
      "role": "Role",
      "status": "Status",
      "lastLogin": "Last Login",
      "created": "Created",
      "actions": "Actions",
      "noResults": "No users found",
      "roles": "Roles"
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "date": {
      "never": "Never"
    },
    "actions": {
      "label": "Actions",
      "copyId": "Copy user ID",
      "editUser": "Edit user",
      "openMenu": "Open menu",
      "viewDetails": "View details"
    },
    "filter": {
      "allRoles": "All Roles",
      "allStatus": "All Status"
    },
    "search": {
      "placeholder": "Search by username..."
    },
    "error": {
      "create": "Failed to create user",
      "delete": "Failed to deactivate user",
      "resetPassword": "Failed to reset password",
      "resendInvitation": "Failed to resend invitation",
      "activate": "Failed to activate user",
      "demote": "Failed to demote user",
      "promote": "Failed to promote user"
    },
    "role": {
      "USER": "User",
      "ADMIN": "Admin",
      "SUPERADMIN": "Super Admin"
    },
    "modal": {
      "add": {
        "title": "Add New User",
        "description": "Create a new user account. An invitation link will be generated.",
        "name": "Name",
        "namePlaceholder": "Enter full name...",
        "email": "Email",
        "emailPlaceholder": "Enter email...",
        "emailOptional": "Email (optional)",
        "identifierHint": "Enter a username, an email, or both — the user signs in with whichever you set.",
        "username": "Username",
        "usernamePlaceholder": "Enter username...",
        "role": "Role",
        "password": "Password (optional)",
        "passwordPlaceholder": "Leave empty to send invitation link",
        "passwordHint": "If left empty, an invitation link will be generated for the user to set their own password.",
        "button": "Create User",
        "rolePlaceholder": "Select a role"
      },
      "invitation": {
        "copied": "Link copied",
        "copyFailed": "Could not copy the link. Copy it manually.",
        "title": "Invitation Link",
        "message": "Share this link with the user to complete their registration.",
        "emailSent": "The invitation was emailed to {{email}}.",
        "emailFailed": "The invitation could not be emailed to {{email}}. Send the link below yourself.",
        "button": {
          "copy": "Copy Link",
          "done": "Done"
        }
      },
      "deactivate": {
        "title": "Deactivate User",
        "message": "Are you sure you want to deactivate {username}?",
        "button": "Deactivate"
      },
      "selfReset": {
        "title": "Reset Your Password",
        "message": "You are about to reset your own password. You will be logged out and need to use the invitation link to log back in.",
        "button": "Reset Password"
      },
      "button": {
        "cancel": "Cancel"
      }
    },
    "card": {
      "total": "total"
    },
    "pagination": {
      "of": "of",
      "page": "Page",
      "rowsPerPage": "Rows per page"
    }
  },
  "counters": {
    "title": "Counters",
    "description": "Manage your counters",
    "newCounter": "New Counter",
    "empty": "No counters yet. Create one to get started!",
    "lastUpdated": "Last updated:",
    "modal": {
      "title": "Create New Counter",
      "description": "Enter a name for your new counter.",
      "nameLabel": "Counter Name",
      "namePlaceholder": "Enter counter name...",
      "cancel": "Cancel",
      "create": "Create"
    },
    "clearAll": "Clear All",
    "clearAllModal": {
      "cancel": "Cancel",
      "confirm": "Delete All",
      "description": "Are you sure you want to delete all {{count}} counters? This action cannot be undone.",
      "title": "Clear All Counters"
    },
    "error": {
      "create": "Failed to create counter",
      "decrement": "Failed to decrement counter",
      "delete": "Failed to delete counter",
      "deleteAll": "Failed to delete all counters",
      "increment": "Failed to increment counter",
      "reset": "Failed to reset counter"
    },
    "loadError": "Could not load counters.",
    "noResults": "No counters match your search.",
    "search": "Search counters...",
    "toast": {
      "incremented": "Counter incremented"
    },
    "total": "total"
  },
  "activity": {
    "table": {
      "timestamp": "Timestamp",
      "action": "Action",
      "entityType": "Entity Type",
      "user": "User",
      "ip": "IP Address",
      "status": "Status",
      "noResults": "No activity logs found"
    },
    "status": {
      "success": "Success",
      "failed": "Failed"
    },
    "filter": {
      "clear": "Clear",
      "allActions": "All Actions",
      "allEntities": "All Entities",
      "allStatus": "All Status"
    },
    "entityType": {
      "session": "Session",
      "user": "User",
      "counter": "Counter"
    },
    "action": {
      "LOGIN": "Login",
      "LOGIN_FAILED": "Login Failed",
      "LOGOUT": "Logout",
      "LOGOUT_ALL": "Logout All",
      "TOKEN_REFRESH": "Token Refresh",
      "CREATE": "Create",
      "UPDATE": "Update",
      "DELETE": "Delete",
      "PASSWORD_SET": "Password Set",
      "PASSWORD_CHANGE": "Password Change",
      "PASSWORD_RESET": "Password Reset",
      "REGISTER": "Register",
      "EMAIL_VERIFY": "Email Verify",
      "RESEND_VERIFICATION": "Resend Verification"
    },
    "search": {
      "placeholder": "Search by username, IP, entity..."
    },
    "button": {
      "details": "Details"
    },
    "modal": {
      "title": "Activity Details"
    },
    "details": {
      "error": "Error",
      "previousState": "Previous State",
      "newState": "New State",
      "metadata": "Metadata",
      "userAgent": "User Agent"
    },
    "pagination": {
      "of": "of",
      "page": "Page",
      "rowsPerPage": "Rows per page"
    }
  },
  "activityHistory": {
    "title": "Activity History",
    "description": "View system audit logs and user activity",
    "card": {
      "total": "entries"
    }
  },
  "toast": {
    "sessionExpired": "Session expired. Please log in again.",
    "deviceMismatch": "This session belongs to another device. Please log in again.",
    "rateLimited": "Too many requests. Please try again later.",
    "reconnecting": "Reconnecting…",
    "unreachable": "We couldn't reach the server — it may be restarting. Nothing was saved; please try again in a moment."
  },
  "error500": {
    "title": "500 Server Error",
    "subtitle": "Something went wrong on our end",
    "description": "We apologize for the inconvenience. The server encountered an internal error and was unable to complete your request. Our team has been notified.",
    "tryAgain": "Try Again",
    "goHome": "Go Home",
    "errorCode": "Error code"
  },
  "backend": {
    "accountLocked": "Too many failed login attempts. Try again in {{seconds}} seconds",
    "accountLockedTitle": "Account temporarily locked",
    "badRequest": "The request was invalid",
    "cannotAssignCustomerRole": "The Customer role cannot be assigned to admin-managed users",
    "cannotDeactivateOwnAccount": "You cannot deactivate your own account",
    "cannotDeleteOwnAccount": "You cannot delete your own account",
    "cannotDeleteSuperAdmin": "Super Admin users cannot be deleted",
    "cannotModifyOwnRoles": "You cannot modify your own roles",
    "cannotModifyOwnSuperAdmin": "You cannot modify your own Super Admin status",
    "cannotResendSuperAdminInvitation": "Invitations cannot be resent for Super Admin users",
    "cannotResetSuperAdminPassword": "The password of a Super Admin cannot be reset here",
    "cannotUpdateSuperAdmin": "Super Admin users cannot be updated",
    "conflict": "This already exists",
    "counterNotFound": "Counter not found",
    "currentPasswordIncorrect": "Current password is incorrect",
    "emailAlreadyVerified": "This email is already verified. You can log in.",
    "emailExists": "This email is already registered",
    "emailNotVerified": "Please verify your email before logging in",
    "emailRequired": "Email is required",
    "fetchActivityFailed": "Could not load activity",
    "fetchProfileFailed": "Could not load your profile",
    "fetchSessionsFailed": "Could not load your sessions",
    "fetchUsersFailed": "Could not load users",
    "forbidden": "You don't have permission to do that",
    "identifierInUse": "That username or email is already in use",
    "identifierRequired": "Username or email is required",
    "invalidCredentials": "Invalid username or password",
    "invalidEmail": "Invalid email format",
    "invalidInvitationToken": "Invalid or expired invitation link",
    "invalidResetToken": "This password reset link is invalid or has expired",
    "invalidVerificationToken": "This verification link is invalid or has expired",
    "logoutAllFailed": "Could not log out the other sessions",
    "logoutFailed": "Logout failed",
    "newPasswordSameAsCurrent": "New password must be different from current password",
    "noPlatformAccess": "Your account does not have access to this application",
    "notFound": "Not found",
    "onlySuperAdminsCreateSuperAdmins": "Only Super Admins can create Super Admin users",
    "onlySuperAdminsManageSuperAdmins": "Only Super Admins can manage Super Admin status",
    "passwordAlreadySet": "This user has already set a password. Use password reset instead.",
    "passwordComplexity": "Password does not meet requirements",
    "passwordMinLength": "Password must be at least {{count}} characters",
    "passwordNotSet": "This account has no password set",
    "passwordSetupRequired": "You must set your password before logging in",
    "profileNotFound": "Profile not found",
    "registrationFailed": "Registration failed",
    "registrationUnavailable": "Registration is not available",
    "resetPasswordFailed": "Failed to reset password",
    "revokeSessionFailed": "Could not revoke the session",
    "securityCheckFailed": "Security check failed. Please reload the page and try again.",
    "serverError": "Something went wrong on our side. Please try again.",
    "sessionNotFound": "Session not found",
    "tooManyLoginAttempts": "Too many login attempts. Try again in {{seconds}} seconds",
    "updateUserFailed": "Failed to update user",
    "userNotFound": "User not found",
    "usernameDerivedFromEmail": "The username is derived from the email when login is by email",
    "usernameExists": "Username already exists",
    "usernameRequired": "Username is required",
    "verificationFailed": "Verification failed",
    "verificationUnavailable": "Email verification is not available",
    "verifyInvitationFailed": "Could not verify the invitation",
    "accountDeactivated": "Account is deactivated",
    "accountLockedFor": "Account locked for {{seconds}} seconds",
    "invalidPassword": "Invalid password",
    "invalidPasswordLocked": "Invalid password – account locked for {{seconds}} seconds",
    "passwordPolicyDefault": "Password must contain uppercase, lowercase, number, and special character",
    "platformAccessDenied": "Access denied for this platform ({{platform}})",
    "sendVerificationFailed": "The verification email could not be sent"
  },
  "dataTable": {
    "clearFilters": "Clear filters",
    "columns": "Columns",
    "noResults": "No results.",
    "pagination": {
      "next": "Next",
      "pageOf": "Page {{page}} of {{pageCount}}",
      "perPage": "{{count}} / page",
      "previous": "Previous",
      "showing": "Showing {{from}} to {{to}} of {{total}} results"
    },
    "rowsSelected": "{{selected}} of {{total}} row(s) selected.",
    "searchPlaceholder": "Search...",
    "column": {
      "actions": "Actions",
      "createdAt": "Created",
      "isActive": "Status",
      "lastLoginAt": "Last Login",
      "name": "Name",
      "roles": "Roles",
      "username": "Username"
    }
  },
  "forgotPassword": {
    "backToLogin": "Back to login",
    "description": "Enter your email and we will send you a reset link.",
    "email": "Email",
    "emailPlaceholder": "Enter your email",
    "sent": {
      "description": "If an account exists with this email, you will receive a reset link.",
      "title": "Check your email"
    },
    "submit": "Send Reset Link",
    "title": "Forgot Password"
  },
  "password": {
    "error": {
      "complexity": "Password does not meet requirements",
      "minLength": "Password must be at least {{count}} characters"
    },
    "requirement": {
      "complexity": "Meets complexity requirements",
      "minLength": "At least {{count}} characters"
    }
  },
  "register": {
    "button": "Create account",
    "button.loading": "Creating account...",
    "confirmPassword": {
      "label": "Confirm Password",
      "placeholder": "Confirm your password"
    },
    "description": "Enter your details to create your account",
    "email": {
      "label": "Email",
      "placeholder": "Enter your email"
    },
    "error": {
      "failed": "Registration failed. Please try again.",
      "invalidEmail": "Please enter a valid email address",
      "nameRequired": "Name is required",
      "passwordLength": "Password must be at least 8 characters",
      "passwordMismatch": "Passwords do not match"
    },
    "hasAccount": "Already have an account?",
    "name": {
      "label": "Name",
      "placeholder": "Enter your name"
    },
    "password": {
      "label": "Password",
      "placeholder": "Enter your password"
    },
    "signIn": "Sign in",
    "success": "Registration successful! Please check your email to verify your account.",
    "title": "Create an account"
  },
  "resetPassword": {
    "confirmPassword": "Confirm Password",
    "description": "Enter your new password below.",
    "error": "Failed to reset password",
    "goToLogin": "Go to Login",
    "invalid": {
      "description": "This password reset link has expired or is invalid. Please request a new one.",
      "title": "Invalid or Expired Link"
    },
    "newPassword": "New Password",
    "passwordInvalid": "Password does not meet requirements",
    "passwordMismatch": "Passwords do not match",
    "requestNew": "Request New Link",
    "submit": "Reset Password",
    "success": "Password reset successfully",
    "success.description": "You will be redirected to login shortly.",
    "success.title": "Password Reset Successfully",
    "title": "Reset Password"
  },
  "verifyEmail": {
    "error": {
      "invalidToken": "This verification link is invalid or has expired.",
      "noToken": "No verification token provided",
      "title": "Verification Failed"
    },
    "goToLogin": "Go to Login",
    "needAccount": "Don't have an account?",
    "resend": {
      "button": "Resend Verification Email",
      "cancel": "Cancel",
      "email": {
        "label": "Email Address",
        "placeholder": "Enter your email"
      },
      "emailRequired": "Please enter your email",
      "sending": "Sending...",
      "submit": "Send",
      "success": "If your email is registered, you will receive a verification email."
    },
    "signUp": "Sign up",
    "success": {
      "description": "Your email has been verified successfully. You can now log in to your account.",
      "redirect": "Redirecting to login...",
      "title": "Email Verified!"
    }
  }
}
